import React from 'react'
import { Icon } from '@iconify/react'
import { showSuccessToast, showErrorToast } from '../../utils/showToast'

const CopyToClipboard = ({ value }) => {
  const handleCopy = () => {
    // Kiểm tra nếu API clipboard có sẵn
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          showSuccessToast('Sao chép thành công!')
        })
        .catch((err) => {
          showErrorToast('Failed to copy: ' + err.message)
        })
    } else {
      // Nếu không có API clipboard, sử dụng cách thông thường
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      showSuccessToast('Sao chép thành công!')
    }
  }

  return (
    <div onClick={handleCopy} className="ml-1 cursor-pointer">
      <Icon icon="ph:copy-simple" className="text-secondarygray" />
    </div>
  )
}

export default CopyToClipboard
